var s = Object.defineProperty;
var i = (a, o, t) => o in a ? s(a, o, { enumerable: !0, configurable: !0, writable: !0, value: t }) : a[o] = t;
var e = (a, o, t) => i(a, typeof o != "symbol" ? o + "" : o, t);
class c {
  constructor() {
    /**
     * Adobe SDK path
     *
     */
    e(this, "adobeSDK", "https://assets.adobedtm.com/0a9348ad03c2/c7e2a344c6e9/launch-f2b090ffdcc1-development.min.js");
    /**
     * Channel ID
     *
     */
    e(this, "channelId", 48);
    /**
     * Default api protocol
     *
     */
    e(this, "protocol", "https");
    /**
     * Disable logging by default
     *
     */
    e(this, "logging", !1);
    /**
     * Disable sending headers
     *
     */
    e(this, "disabledHeaders", !1);
    /**
     * Key for cookie notice consent
     *
     */
    e(this, "cookieNoticeName", "wmCookieNotice");
    /**
     * Hot deal image path on LOCAL environment
     *
     */
    e(this, "hotDealImage", "https://image.webmotors.com.br/feiroes/imagens/hml/_portal/");
    /**
     * Cookie Save last search and Last DA
     *
     */
    e(this, "lastSearchCookieName", "WMLastFilterSearch");
    /**
     * Cookie Save last searches
     *
     */
    e(this, "lastSearchesCookieName", "WebMotorsLastSearches");
    /**
     * Crypto secret
     *
     */
    e(this, "secretKey", "twY2NMFSKMskM8NteG9bwBkx");
    /**
     * Data form cookie name
     *
     */
    e(this, "formDataCookieName", "WebMotorsDataForm");
    /**
     * Geolocation cookie name
     *
     */
    e(this, "geolocationCookieName", "WebMotorsLocation");
    /**
     * Cookie search segment key
     *
     */
    e(this, "cookieSearchSegmentKey", "WebMotorsVehicleType");
  }
  /**
   * Indicates if the environment is server side
   *
   * @returns
   */
  isServerSide() {
    return globalThis.window === void 0;
  }
}
export {
  c as BaseEnvironment
};
